module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "container container_com-fundo container_com-margem"
  }, [_c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _c('alerta', {
    attrs: {
      "tipo": _vm.tipoDeAlerta,
      "texto": _vm.mensagemDeAlerta
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "formulario",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.salvarEmpreendimento.apply(null, arguments)
      }
    }
  }, [_c('h2', {
    staticClass: "titulo titulo_grande"
  }, [_vm._v("\n        Preencha todos os campos obrigatórios abaixo para editar o\n        empreendimento.\n      ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_5"
  }, [_c('label', {
    attrs: {
      "id": "nome"
    }
  }, [_vm._v("Informe o nome da Construtora")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empreendimento.NomeDaConstrutora),
      expression: "empreendimento.NomeDaConstrutora"
    }],
    staticClass: "input uppercase",
    attrs: {
      "name": "nomeDaConstrutora",
      "type": "text",
      "id": "nomeDoEmpreendimento",
      "alt": "Informe o nome da Construtora",
      "placeholder": "Ex: RG ENGENHARIA LTDA",
      "required": ""
    },
    domProps: {
      "value": (_vm.empreendimento.NomeDaConstrutora)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empreendimento, "NomeDaConstrutora", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "example-input"
  }, [_vm._v("Ex: RG ENGENHARIA LTDA")])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_2"
  }, [_c('label', [_vm._v("CNPJ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empreendimento.CnpjDaConstrutora),
      expression: "empreendimento.CnpjDaConstrutora"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('99.999.999/9999-99'),
      expression: "'99.999.999/9999-99'"
    }],
    staticClass: "input",
    attrs: {
      "name": "numeroCNPJdaConstrutora",
      "type": "text",
      "id": "nomeDoEmpreendimento",
      "placeholder": "Ex: 00.192.450/0001-23",
      "required": ""
    },
    domProps: {
      "value": (_vm.empreendimento.CnpjDaConstrutora)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empreendimento, "CnpjDaConstrutora", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "example-input"
  }, [_vm._v("Ex: 00.192.450/0001-23")])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_"
  }, [_c('label', [_vm._v("Dados bancários")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empreendimento.ContaDaConstrutora),
      expression: "empreendimento.ContaDaConstrutora"
    }],
    staticClass: "input uppercase",
    attrs: {
      "name": "dadosBancariosConstutora",
      "type": "text",
      "id": "nomeDoEmpreendimento",
      "placeholder": "Ex: AGENCIA 2054 OP 003 C/C 2708-6",
      "required": ""
    },
    domProps: {
      "value": (_vm.empreendimento.ContaDaConstrutora)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empreendimento, "ContaDaConstrutora", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "example-input"
  }, [_vm._v("Ex: AGENCIA 2054 OP 003 C/C 2708-6")])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Projeto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empreendimento.ProjetoDeSubsidioId),
      expression: "empreendimento.ProjetoDeSubsidioId"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.empreendimento, "ProjetoDeSubsidioId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.obterCotas]
    }
  }, _vm._l((_vm.projetos), function(projeto) {
    return _c('option', {
      domProps: {
        "value": projeto.Id,
        "selected": projeto.Id === _vm.empreendimento.ProjetoDeSubsidioId ?
          'selected' :
          ''
      }
    }, [_vm._v("\n              " + _vm._s(projeto.Nome) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empreendimento.CidadeId),
      expression: "empreendimento.CidadeId"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.empreendimento, "CidadeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.obterCotas]
    }
  }, _vm._l((_vm.cidades), function(cidade) {
    return _c('option', {
      domProps: {
        "value": cidade.Id,
        "selected": cidade.Id === _vm.empreendimento.CidadeId ? 'selected' : ''
      }
    }, [_vm._v("\n              " + _vm._s(cidade.Nome) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Tipo de imóvel")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empreendimento.TipoDeEmpreendimento),
      expression: "empreendimento.TipoDeEmpreendimento"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.empreendimento, "TipoDeEmpreendimento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.tiposDeEmpreendimento), function(tipoDeEmpreendimento) {
    return _c('option', {
      domProps: {
        "value": tipoDeEmpreendimento.Id,
        "selected": _vm.empreendimento.TipoDeEmpreendimento ===
          tipoDeEmpreendimento.Id ?
          'selected' :
          ''
      }
    }, [_vm._v("\n              " + _vm._s(tipoDeEmpreendimento.Nome) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "nomeDoEmpreendimento"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empreendimento.Nome),
      expression: "empreendimento.Nome"
    }],
    staticClass: "input uppercase",
    attrs: {
      "name": "nomeDoEmpreendimento",
      "type": "text",
      "id": "nomeDoEmpreendimento",
      "placeholder": "Ex: CONDOMÍNIO RESIDENCIAL ITACIRA",
      "required": ""
    },
    domProps: {
      "value": (_vm.empreendimento.Nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empreendimento, "Nome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "example-input"
  }, [_vm._v("Ex: CONDOMÍNIO RESIDENCIAL ITACIRA")])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_2"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "quantidadeDeImoveisDisponiveis"
    }
  }, [_vm._v("Total de imóveis do empreendimento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empreendimento.QuantidadeDeImoveisDisponiveis),
      expression: "empreendimento.QuantidadeDeImoveisDisponiveis"
    }],
    staticClass: "input uppercase",
    attrs: {
      "name": "quantidadeDeImoveisDisponiveis",
      "type": "number",
      "id": "quantidadeDeImoveisDisponiveis",
      "placeholder": "Ex: 100",
      "required": ""
    },
    domProps: {
      "value": (_vm.empreendimento.QuantidadeDeImoveisDisponiveis)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empreendimento, "QuantidadeDeImoveisDisponiveis", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "example-input"
  }, [_vm._v("Ex: 100")])]), _vm._v(" "), (_vm.empreendimento.ProjetoEhBonusMoradia) ? _c('div', {
    staticClass: "grade__coluna grade__coluna_2"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "totalDeCotas"
    }
  }, [_vm._v("Cotas disponíveis")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empreendimento.CotasDeDisponiveis),
      expression: "empreendimento.CotasDeDisponiveis"
    }],
    staticClass: "input uppercase",
    attrs: {
      "name": "totalDeCotas",
      "type": "number",
      "id": "totalDeCotas",
      "placeholder": "Ex: 100",
      "required": ""
    },
    domProps: {
      "value": (_vm.empreendimento.CotasDeDisponiveis)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empreendimento, "CotasDeDisponiveis", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "example-input"
  }, [_vm._v("Ex: 100")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('label', {
    staticClass: "formulario__label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empreendimento.EhTerrenoPublicoDoado),
      expression: "empreendimento.EhTerrenoPublicoDoado"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.empreendimento.EhTerrenoPublicoDoado) ? _vm._i(_vm.empreendimento.EhTerrenoPublicoDoado, null) > -1 : (_vm.empreendimento.EhTerrenoPublicoDoado)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.empreendimento.EhTerrenoPublicoDoado,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.empreendimento, "EhTerrenoPublicoDoado", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.empreendimento, "EhTerrenoPublicoDoado", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.empreendimento, "EhTerrenoPublicoDoado", $$c)
        }
      }
    }
  }), _vm._v("\n            Terreno público doado\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [(_vm.empreendimento.ProjetoEhBonusMoradia) ? _c('div', {
    staticClass: "grade__coluna grade__coluna_2"
  }, [_c('p', {
    staticClass: "texto-informativo"
  }, [_vm._v("\n            Total de cotas disponibilizadas:\n            "), _c('strong', [_vm._v(_vm._s(_vm.empreendimento.CotaDeImoveis))])])]) : _vm._e(), _vm._v(" "), (_vm.empreendimento.ProjetoEhBonusMoradia) ? _c('div', {
    staticClass: "grade__coluna grade__coluna_2"
  }, [_c('p', {
    staticClass: "texto-informativo"
  }, [_vm._v("\n            Cotas utilizadas:\n            "), _c('strong', [_vm._v(_vm._s(_vm.empreendimento.CotasDeImoveisUsadas))])])]) : _vm._e(), _vm._v(" "), (_vm.empreendimento.ProjetoEhBonusMoradia) ? _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('p', {
    staticClass: "texto-informativo"
  }, [_vm._v("\n            Total de cotas disponíveis no município:\n            "), _c('strong', [_vm._v(_vm._s(_vm.empreendimento.CotasDisponiveisNoMunicipio))])])]) : _vm._e()]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "formulario"
  }, [_c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cpfDoCorrespondente),
      expression: "cpfDoCorrespondente"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('999.999.999-99'),
      expression: "'999.999.999-99'"
    }],
    attrs: {
      "id": "cpf",
      "type": "text",
      "placeholder": "Insira somente números do CPF"
    },
    domProps: {
      "value": (_vm.cpfDoCorrespondente)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cpfDoCorrespondente = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [(true) ? _c('button', {
    staticClass: "no-print botao botao_cor-terciaria botao_com-icone-para-direita botao_sem-preenchimento botao_medio",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.adicionarCorrespondente
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Adicionar\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, _vm._l((_vm.empreendimento.Usuarios), function(correspondente, index) {
    return _c('div', {
      key: index,
      staticClass: "grade__coluna grade__coluna_2"
    }, [_c('section', {
      staticClass: "card-correspondente"
    }, [_c('header', {
      staticClass: "card-header"
    }, [_c('i', {
      staticClass: "fa-light fa-user"
    }), _vm._v(" "), _c('button', {
      staticClass: "delete-btn",
      attrs: {
        "type": "button",
        "title": "Excluir"
      },
      on: {
        "click": function($event) {
          return _vm.removerCorrespondente(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa-light fa-trash"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-body"
    }, [_c('h2', {
      staticClass: "card-title"
    }, [_vm._v(_vm._s(correspondente.Nome))]), _vm._v(" "), _c('p', {
      staticClass: "card-subtitle"
    }, [_vm._v(_vm._s(correspondente.Cpf))])])])])
  }), 0)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('router-link', {
    staticClass: "botao botao_medio botao_cinza u-margem-direita-pequena",
    class: {
      'is-disabled': _vm.loading.visivel
    },
    attrs: {
      "to": {
        name: 'VisualizarEmpreendimento',
        query: {
          idDoEmpreendimento: _vm.empreendimentoId
        },
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_medio botao_cor-terciaria",
    class: {
      'is-loading': _vm.loading.visivel
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          Salvar empreendimento\n        ")])], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "subtitle is-5"
  }, [_c('i', {
    staticClass: "fal fa-user-hard-hat"
  }), _vm._v(" Dados da construtora\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "subtitle is-5"
  }, [_c('i', {
    staticClass: "fal fa-building"
  }), _vm._v(" Novo empreendimento\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "subtitle is-5"
  }, [_c('i', {
    staticClass: "fal fa-building-columns"
  }), _vm._v(" Dados de correspondentes\n        bancários\n      ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-119f8c89", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-119f8c89"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/empreendimentos/EditarEmpreendimento.vue
// module id = 1092
// module chunks = 1